angular.module('storefrontApp')
    .controller('recommendationsController', [
        '$scope',
        '$window',
        '$timeout',
        'recommendationService',
        function (
            $scope,
            $window,
            $timeout,
            recommendationService,
        ) {
            $scope.isBlockVisible = false;
            $scope.productListRecommendationsLoaded = false;
            $scope.productListRecommendations = [];

            $scope.getRecommendations = function (evalContext) {
                if (_.isString(evalContext.productIds)) {
                    if (evalContext.productIds.match(',')) {
                        const values = evalContext.productIds.split(',');
                        evalContext.productIds = values;
                    } else {
                        evalContext.productIds = [evalContext.productIds];
                    }
                }

                recommendationService.getRecommendedProducts(evalContext)
                    .then(function (response) {
                        const products = response.data;

                        if (products.length) {
                            for (let i = 0; i < products.length; i += 1) {
                                $scope.productListRecommendations.push(products[i]);
                            }

                            $scope.isBlockVisible = products.length > 0;
                        }

                        $scope.productListRecommendationsLoaded = true;
                    });
            };
        }]);
